export default "__VITE_ASSET__oIxrJZQZ__"